// extracted by mini-css-extract-plugin
export default {"button":"PrivateButtons_button__TyaqQ"};